import type { NewsArticle } from "@/types";

export const news: NewsArticle[] = [
  {
    id: "n1",
    title: "湖人主场加时险胜凯尔特人，末节连续关键球定胜负",
    excerpt:
      "两队上演经典东西部对话，湖人在第四节落后的情况下依靠内线强攻追平比分，加时赛完成逆转。",
    content:
      "本轮NBA常规赛迎来焦点之战，洛杉矶湖人坐镇主场迎战波士顿凯尔特人。比赛前三节双方比分紧咬，凯尔特人依靠外线三分一度建立两位数领先。进入第四节，湖人加强内线冲击，连续利用篮板球二次进攻缩小分差，并在常规时间结束前将比分追平。加时赛中，湖人核心球员连续命中关键球，最终完成逆转，拿下这场含金量十足的胜利。全场数据显示，湖人在篮板球和禁区得分上占据明显优势，成为取胜的关键因素。",
    category: "赛况",
    date: "2026-10-12 22:40",
    author: "赛事编辑部",
    image:
      "https://readdy.ai/api/search-image?query=Dramatic%20basketball%20arena%20interior%20with%20spotlights%20on%20wooden%20court%2C%20crowd%20blurred%20in%20background%2C%20orange%20and%20blue%20lighting%2C%20cinematic%20sports%20photography%2C%20high%20detail&width=800&height=500&seq=nba-news-01&orientation=landscape",
    tags: ["湖人", "凯尔特人", "常规赛"],
  },
  {
    id: "n2",
    title: "库里三分绝杀！勇士客场一分险胜湖人延续连胜",
    excerpt:
      "比赛最后十秒，勇士当家球星命中高难度三分，帮助球队在客场险胜对手，豪取五连胜。",
    content:
      "在一场备受瞩目的西部内战中，金州勇士客场挑战洛杉矶湖人。双方全场比分胶着，第四节最后时刻湖人一度反超。暂停回来后，勇士布置最后一攻，当家球星在三分线外顶着防守命中高难度投篮，完成准绝杀。湖人最后一攻未能命中，勇士最终以三分优势带走胜利。赛后勇士主教练表示，球队在关键回合的执行力是取胜的根本，全队三分命中率超过四成。",
    category: "战报",
    date: "2026-10-12 10:15",
    author: "战报组",
    image:
      "https://readdy.ai/api/search-image?query=Basketball%20player%20silhouette%20shooting%20three%20pointer%20in%20dark%20arena%20with%20dramatic%20spotlight%2C%20motion%20blur%2C%20orange%20rim%20light%2C%20cinematic%20sports%20photography%2C%20high%20contrast&width=800&height=500&seq=nba-news-02&orientation=landscape",
    tags: ["勇士", "湖人", "三分"],
  },
  {
    id: "n3",
    title: "约基奇再度拿下三双，掘金主场轻取对手稳居西部前列",
    excerpt:
      "掘金核心砍下三双数据，球队全场掌控节奏，主场轻松拿下胜利，继续稳固西部排名。",
    content:
      "丹佛掘金在主场迎来一场常规赛较量。球队核心中锋再度送上三双数据，不仅在进攻端串联全队，还多次送出精妙助攻帮助队友得分。掘金全场保持领先，替补席同样贡献稳定火力。凭借本场胜利，掘金继续稳固西部前列的位置，主教练赛后对球队的攻防转换效率表示满意。",
    category: "数据",
    date: "2026-10-11 23:05",
    author: "数据观察",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20basketball%20arena%20scoreboard%20glowing%20with%20statistics%20and%20numbers%2C%20dark%20blue%20atmosphere%2C%20cinematic%20sports%20photography%2C%20depth%20of%20field%2C%20high%20detail&width=800&height=500&seq=nba-news-03&orientation=landscape",
    tags: ["掘金", "三双", "数据"],
  },
  {
    id: "n4",
    title: "联盟最新交易流言：多支球队有意补强锋线阵容",
    excerpt:
      "随着赛季深入，多支争冠球队开始寻求锋线补强，联盟交易市场逐渐升温。",
    content:
      "随着NBA常规赛进入关键阶段，各支球队的管理层开始为季后赛布局。据多家媒体消息，多支具备竞争力的球队正在积极评估补强锋线阵容的可能性，以提升球队的防守强度和外线投射。联盟交易市场的动向将成为接下来一段时间球迷关注的焦点，最终能否达成交易仍存在诸多变数。",
    category: "交易",
    date: "2026-10-11 16:20",
    author: "前线记者",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20basketball%20locker%20room%20with%20jerseys%20hanging%2C%20warm%20spotlights%2C%20editorial%20sports%20photography%2C%20clean%20composition%2C%20high%20detail&width=800&height=500&seq=nba-news-04&orientation=landscape",
    tags: ["交易", "联盟动态"],
  },
  {
    id: "n5",
    title: "塔图姆砍下全队最高分，凯尔特人主场大胜热火",
    excerpt: "凯尔特人全场三分手感火热，下半场一波流锁定胜局，主场轻取热火。",
    content:
      "波士顿凯尔特人在主场迎战迈阿密热火。球队核心前锋砍下全队最高分，带领球队在下半场打出一波进攻高潮，迅速拉开分差。凯尔特人全场命中率与三分命中率均高于对手，防守端同样限制了热火的进攻节奏，最终轻松拿下比赛。",
    category: "战报",
    date: "2026-10-11 11:30",
    author: "战报组",
    image:
      "https://readdy.ai/api/search-image?query=Green%20and%20white%20basketball%20jersey%20texture%20closeup%20with%20soft%20arena%20lighting%2C%20clean%20background%2C%20editorial%20sports%20photography%2C%20high%20detail&width=800&height=500&seq=nba-news-05&orientation=landscape",
    tags: ["凯尔特人", "热火"],
  },
  {
    id: "n6",
    title: "花边：球星赛后与球迷互动，暖心举动获赞无数",
    excerpt: "比赛结束后，一位球星主动与场边小球迷合影并赠送球衣，暖心举动引发热议。",
    content:
      "在昨日比赛结束之后，一位NBA球星走向场边，主动与一名小球迷合影留念，并将自己的比赛球衣赠送给对方。这一暖心举动被现场摄像机捕捉后迅速在社交媒体传播，获得了大量球迷点赞。球员赛后表示，正是球迷的支持让比赛更有意义。",
    category: "花边",
    date: "2026-10-10 20:45",
    author: "花边频道",
    image:
      "https://readdy.ai/api/search-image?query=Basketball%20ball%20resting%20on%20wooden%20court%20floor%20under%20warm%20arena%20lights%2C%20soft%20shadows%2C%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=800&height=500&seq=nba-news-06&orientation=landscape",
    tags: ["花边", "球迷"],
  },
  {
    id: "n7",
    title: "数据榜更新：多名新星跻身得分榜前列",
    excerpt: "最新数据榜单显示，多位年轻球员本赛季表现抢眼，跻身联盟得分榜前列。",
    content:
      "联盟最新一期的球员数据榜单出炉。多名年轻球员凭借出色的个人表现跻身得分榜前列，展现出新生代球员的强劲实力。与此同时，效率值、助攻失误比等进阶数据显示，这些新星在团队配合方面同样进步明显，联盟格局正在悄然发生变化。",
    category: "数据",
    date: "2026-10-10 09:10",
    author: "数据观察",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20of%20basketball%20statistics%20charts%20in%20blue%20and%20orange%20glow%2C%20dark%20background%2C%20modern%20digital%20design%2C%20high%20detail&width=800&height=500&seq=nba-news-07&orientation=landscape",
    tags: ["数据", "新星"],
  },
  {
    id: "n8",
    title: "赛程展望：本周末多场焦点对决值得期待",
    excerpt: "本周末NBA将迎来多场强强对话，多支球队冲击连胜，观赛体验拉满。",
    content:
      "本周末，NBA赛场将迎来多场焦点对决，东西部多支强队正面交手。其中包括勇士与凯尔特人的王朝碰撞、掘金与森林狼的内线大战等。多支球队正处于连胜或冲击排名的关键阶段，这些比赛的结果将对季后赛格局产生重要影响，值得球迷重点关注。",
    category: "赛况",
    date: "2026-10-09 18:00",
    author: "赛事编辑部",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20shot%20of%20basketball%20court%20from%20upper%20stands%20with%20glowing%20arena%20lights%2C%20blue%20and%20orange%20tone%2C%20cinematic%20sports%20photography%2C%20high%20detail&width=800&height=500&seq=nba-news-08&orientation=landscape",
    tags: ["赛程", "前瞻"],
  },
];

export const newsMap: Record<string, NewsArticle> = news.reduce(
  (acc, article) => {
    acc[article.id] = article;
    return acc;
  },
  {} as Record<string, NewsArticle>,
);